module.exports = __webpack_public_path__ + "static/media/women-fas-cat-10.61ebd78c.png";